export var IssueAssessmentStatus;
(function (IssueAssessmentStatus) {
    IssueAssessmentStatus["AwaitingClosure"] = "awaitingclosure";
    IssueAssessmentStatus["Closed"] = "closed";
    IssueAssessmentStatus["Declined"] = "declined";
    IssueAssessmentStatus["FirstLineApproval"] = "firstlineapproval";
    IssueAssessmentStatus["Open"] = "open";
    IssueAssessmentStatus["Pending"] = "pending";
})(IssueAssessmentStatus || (IssueAssessmentStatus = {}));
//# sourceMappingURL=issue-assessment-status.js.map